import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { AdvanceInitTitle, DataTitle } from "../../../../../Constants/Constants";
import RowCreateCallback from "./RowCreateCallback";
import StockResult from "./StockResult";

const AdvanceInitContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AdvanceInitTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <StockResult />
          <RowCreateCallback />
        </Row>
      </Container>
    </>
  );
};
export default AdvanceInitContainer;
